import React from "react";
import { useNavigate } from "react-router-dom";

const CommonCTA = ({
  title = "Looking for Genuine Land in Idukki?",
  bgColor = "#E2E8D7",
  primaryText = "View Available Properties",
  secondaryText = "Contact Us",
  primaryRoute = "/properties",
  secondaryRoute = "/contact-us",
}) => {
  const navigate = useNavigate();

  return (
    <div className="pb-20">
      <section
        className="py-16 text-center px-4"
        style={{ backgroundColor: bgColor }}
      >
        <h2 className="text-2xl md:text-3xl font-serif text-[#45A301] mb-6">
          {title}
        </h2>

        <div className="flex flex-col md:flex-row justify-center gap-4">
          <button
            onClick={() => navigate(primaryRoute)}
            className="bg-[#45A301] text-white px-6 py-2.5 rounded-lg"
          >
            {primaryText}
          </button>

          <button
            onClick={() => navigate(secondaryRoute)}
            className="border border-[#45A301] text-[#45A301] px-6 py-2.5 rounded-lg"
          >
            {secondaryText}
          </button>
        </div>
      </section>
    </div>
  );
};

export default CommonCTA;